import {
  AppBar, Button, CheckBox, enableRipple, MaskedTextBox, TextBox, Tooltip
} from './libraries/ej2.mjs';
import LanguageSelector from './layouts/components.mjs';
import './libraries/fontawesome.mjs';
import './app.scss';

enableRipple(true);

const appBar = new AppBar({
  colorMode: 'Dark',
  cssClass: 'flc-appbar'
});
appBar.appendTo(document.querySelector('body > header'));

const btnToggler = new Button({
  cssClass: 'e-inherit',
  iconCss: 'e-icons e-menu'
});
btnToggler.appendTo(appBar.element.querySelector('.toggler'));

document.querySelectorAll('input:not([type="hidden"]):not([type="file"])')
  .forEach((element) => {
    if (element.getAttribute('type') === 'checkbox') {
      new CheckBox({
        label: element.dataset.label
      }).appendTo(element);
    } else if (element.dataset.mask) {
      new MaskedTextBox({
        mask: element.dataset.mask,
        floatLabelType: 'Auto'
      }).appendTo(element);
    } else {
      new TextBox({
        floatLabelType: 'Auto'
      }).appendTo(element);
    }
  });

document.querySelectorAll('button')
  .forEach((element) => {
    new Button({
      isPrimary: element.getAttribute('type') === 'submit'
    }).appendTo(element);
  });

document.querySelectorAll('.btn-primary')
  .forEach((element) => {
    new Button({
      isPrimary: true
    }).appendTo(element);
  });

document.querySelectorAll('.nav-link, .btn-link')
  .forEach((element) => {
    new Button({
      cssClass: 'e-flat'
    }).appendTo(element);
  });

document.querySelectorAll('[title]')
  .forEach((element) => {
    new Tooltip({
      content: element.getAttribute('title')
    }).appendTo(element);
  });

document.querySelector('flc-language-selector')
  .on('change', (e) => {
    window.location.href = e.target.selected.uri;
  });
